import React from "react";
import NavUI from "./NavUI";
import { DashBoardIcon, CreditIcon } from "../CustomIcon";

import "../../styles/Guide.css";

const ReportNav = (props) => {
  const pages = [
    {
      key: "dashboard",
      pathname: "/report/dashboard",
      icon: <DashBoardIcon />,
      title: {
        id: "Report.nav.dashboard",
        text: "Dashboard",
      },
    },
    {
      key: "revenue",
      pathname: "/report/revenue",
      icon: <CreditIcon />,
      title: {
        id: "Report.nav.revenue",
        text: "Revenue",
      },
    },
  ];

  return <NavUI selectedKey={props.selectedKey} pages={pages} />;
};

export default ReportNav;
